import { render, staticRenderFns } from "./AddDiscountForm.vue?vue&type=template&id=4e0082a1&scoped=true&"
import script from "./AddDiscountForm.vue?vue&type=script&lang=js&"
export * from "./AddDiscountForm.vue?vue&type=script&lang=js&"
import style0 from "./AddDiscountForm.vue?vue&type=style&index=0&id=4e0082a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0082a1",
  null
  
)

component.options.__file = "AddDiscountForm.vue"
export default component.exports